import type { Component } from 'vue';

import { IconChartBars, IconStore, IconUsers, IconUserSwitch } from '@/shared/ui';

export interface PlatformNavigationItem {
  icon: Component;
  label: string;
  /** Имя маршрута; вложенные маршруты `<name>.*` подсвечивают этот пункт. */
  name: string;
}

export interface PlatformNavigationGroup {
  id: string;
  items: PlatformNavigationItem[];
  label?: string;
}

/** Пункты «Управления» появятся вместе с разделами. */
export const PLATFORM_NAVIGATION: PlatformNavigationGroup[] = [
  {
    id: 'overview',
    items: [{ icon: IconChartBars, label: 'Обзор', name: 'platform.overview' }],
  },
  {
    id: 'clients',
    label: 'Клиенты',
    items: [
      { icon: IconStore, label: 'Организации', name: 'platform.organizations' },
      { icon: IconUsers, label: 'Пользователи', name: 'platform.users' },
    ],
  },
  {
    id: 'support',
    label: 'Поддержка',
    items: [{ icon: IconUserSwitch, label: 'Входы', name: 'platform.audit' }],
  },
];
